import { graphql } from "gql.tada";

export const SlidingThumbnailHeroById = graphql(/* GraphQL */ `
  query SlidingThumbnailHeroById(
    $locale: String
    $preview: Boolean
    $id: String!
  ) {
    slidingThumbnailHero(id: $id, preview: $preview, locale: $locale) {
      ...SlidingThumbnailHeroFragment
    }
  }
  fragment SlidingThumbnailHeroFragment on SlidingThumbnailHero {
    subtitle
    richTextTitle {
      json
    }
    themedMediaItemsCollection {
      items {
        media {
          url
          contentType
        }
        mobileMedia {
          url
          contentType
        }
        theme {
          palette
          foreground
          background
        }
      }
    }
  }
`);
